




















import { ConversationPart } from '@/types';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'embedded-chat-conversation-part',
})
export default class EmbeddedChatConversationPart extends Vue {
  @Prop({ required: true, type: Object})
  part!: ConversationPart;


  get isRequest(): boolean {
    return this.part.type === 'request';
  }

  copyAnswer(part:string) {
    // copie du contenu dans le clipboard
    const body = document.getElementsByTagName("body")[0];
    const elt = document.createElement("input");
    elt.setAttribute('type','text');
    elt.setAttribute('value',part);
    body.appendChild(elt);
    elt.select();
    elt.setSelectionRange(0, 99999); /* For mobile devices */
    document.execCommand("copy");
    elt.remove();
  }

}
